import { Role } from "@/router/_helper";

const reminderSettings = {
  path: "/settings/reminders",
  name: "reminderSettings",
  component: () =>
    import(
      /* webpackChunkName: "reminderSettings" */ "@/views/ReminderSettings.vue"
    ),
  meta: { authorize: [Role.ManageSettings], requiresAuth: true },
};

export default reminderSettings;
